import fetch from "@/utils/request";


export default {
    // 获取银行卡
    getBankCard(data?: any): any {
        return fetch({
            url: "/php/api/bankcard/bank_list",
            method: "get",
            data,
            customLoading: data?.showLoading || false
        });
    },
    getAuthList(data?: any): any {
        return fetch({
            url: "/php/api/account/accountLists",
            method: "post",
            data,
            customLoading: data?.showLoading || false
        });
    },
    getFundsList(data?: object, config = {}): any {
        return fetch({
            url: "/php/api/funds/record_list",
            method: "get",
            data,
            ...config
        });
    },
    // 获取银行卡列表
    geRemittanceList(data?: object): any {
        return fetch({
            url: "/php/api/recharge/remittance_list",
            method: "get",
            data
        });
    },
    postTransfer(data?: object): any {
        return fetch({
            url: "/php/api/transfer/save",
            method: "post",
            data,
            loadingText: "正在划转"
        });
    },
    // 划转记录列表
    getTransferRecords(data?: object, config = {}): any {
        return fetch({
            url: "/php/api/transfer/list",
            method: "get",
            data,
            ...config
        });
    },
    // 取消划转记录
    revokeTransferLog(data?: object): any {
        return fetch({
            url: "/php/api/transfer/cancel",
            method: "post",
            data
        });
    },
    // 获取汇率接口
    fetchCurrencyRate(data?: any, config = {}): any {
        return fetch({
            url: "/php/api/rate/list",
            method: "get",
            data,
            customLoading: data?.showLoading || false,
            ...config
        });
    },
    // 获取换汇资金
    getFunds(data?: object, config = {}): any {
        return fetch({
            url: "/php/api/account/balance/details",
            method: "get",
            data,
            ...config
        });
    },
    // 获取换汇记录
    getExchangeRecords(data?: object, config = {}): any {
        return fetch({
            url: "/php/api/exchange/list",
            method: "get",
            data,
            ...config
        });
    },
    // 取消换汇
    revokeExchangeLog(data?: object): any {
        return fetch({
            url: "/php/api/exchange/cancel",
            method: "post",
            data
        });
    },
    // 获取待办列表
    getAgencyLists(data?: object): any {
        return fetch({
            url: "/php/api/account/agency/lists",
            method: "get",
            data
        });
    },
    // 提交换汇
    saveExchange(data?: object): any {
        return fetch({
            url: "/php/api/exchange/add",
            method: "post",
            data
        });
    },
    
    verifyAccountInfo(data?: object): any {
        return fetch({
            url: "/php/api/account/user/verify",
            method: "post",
            data
        });
    },

    verifyTradePwd(data?: object): any {
        return fetch({
            url: "/php/api/account/transaction/password/verify",
            method: "post",
            data
        });
    },

    setTradePwd(data?: object): any {
        return fetch({
            url: "/php/api/account/transaction/password/set",
            method: "post",
            data
        });
    },
    queryChartData(data?: object): any {
        return fetch({
            url: "/ait0/bapi/v1/third/querychartdata",
            method: "get",
            data,
            headers: {
                "get": {
                    "gf-clientTypes": "APP",
                }
            }
        });
    }
}
